"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const pageLoader_1 = __importDefault(require("../../../router/loaders/pageLoader"));
const AmexSettlementTable = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./settlementTable/amex'))));
const HsbcSettlementTable = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./settlementTable/hsbc'))));
const ViewReceiptAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../wallet/asides/ViewReceiptAside'))));
const SettlementContent = () => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? (0, jsx_runtime_1.jsx)(HsbcSettlementTable, {}) : (0, jsx_runtime_1.jsx)(AmexSettlementTable, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? null : (0, jsx_runtime_1.jsx)(ViewReceiptAside, {}) })] }));
};
exports.default = SettlementContent;
